export default "__VITE_ASSET__70bd7900__"